import React, { useState, useEffect } from "react";
import { SegmentedControl } from "@mantine/core";

const ArtTabs = ({ activeTab, setActiveTab, language, movies, books, games, users }) => {
  const [dotCount, setDotCount] = useState(1);

  const hasLoading = (movies !== undefined && movies === null)
    || (books !== undefined && books === null)
    || (games !== undefined && games === null)
    || (users !== undefined && users === null);

  useEffect(() => {
    if (!hasLoading) return;
    const interval = setInterval(() => {
      setDotCount((prev) => (prev % 3) + 1);
    }, 400);
    return () => clearInterval(interval);
  }, [hasLoading]);

  const tabs = [];
  if (movies !== undefined) tabs.push({ key: "movie", label: language === "ru" ? "Фильмы" : "Movies", data: movies });
  if (books !== undefined) tabs.push({ key: "book", label: language === "ru" ? "Книги" : "Books", data: books });
  if (games !== undefined) tabs.push({ key: "videoGame", label: language === "ru" ? "Игры" : "Games", data: games });
  if (users !== undefined) tabs.push({ key: "users", label: language === "ru" ? "Люди" : "People", data: users });

  const data = tabs.map((tab) => {
    const isLoading = tab.data === null;
    const count = tab.data?.length;
    if (isLoading) {
      const visible = ".".repeat(dotCount);
      const hidden = ".".repeat(3 - dotCount);
      return {
        label: <span>{tab.label} {visible}<span style={{ visibility: 'hidden' }}>{hidden}</span></span>,
        value: tab.key
      };
    }
    const suffix = count !== undefined ? ` (${count})` : "";
    return { label: tab.label + suffix, value: tab.key };
  });

  return (
    <div className="flex justify-center">
      <SegmentedControl
        value={activeTab}
        onChange={setActiveTab}
        data={data}
        radius="xl"
        size="sm"
        styles={{ root: { border: 'none' } }}
      />
    </div>
  );
};

export default ArtTabs;
